module.exports = __webpack_public_path__ + "static/mentor-neeraj-c0356720bcc52a4e9dd1d1ce747df8b9.png";